import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const AppsFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCardList faq="How do I know if my business actually needs a mobile app?">
                  <p>Not every business needs an app—but if you want to:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Improve customer engagement</span>
                    </li>
                    <li>
                      <span>
                        Offer extra/multi-platform convenience (bookings,
                        orders, access)
                      </span>
                    </li>
                    <li>
                      <span>Automate services</span>
                    </li>
                    <li>
                      <span>Build a stronger brand presence</span>
                    </li>
                  </ul>
                  <p>
                    Then a mobile app becomes a powerful growth tool. We help
                    you validate this before development starts.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What if I only have an idea and no technical knowledge?">
                  <p>That’s completely fine. We handle everything:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Idea validation</span>
                    </li>
                    <li>
                      <span>Feature planning</span>
                    </li>
                    <li>
                      <span>Design and development</span>
                    </li>
                    <li>
                      <span>Launch and scaling</span>
                    </li>
                  </ul>
                  <p>
                    You don’t need technical knowledge to have an app on your
                    name — we guide you through the entire process.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to develop a mobile app?">
                  <p>It depends on complexity.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Simple apps: 3–5 weeks</span>
                    </li>
                    <li>
                      <span>Medium apps: 6–10 months</span>
                    </li>
                    <li>
                      <span>Advanced apps: 2–4+ months</span>
                    </li>
                  </ul>
                  <p>
                    We provide a clear timeline after understanding your
                    requirements.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How much does developing a mobile app cost?">
                  <p>Costs depend on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Feature & functionality</span>
                    </li>
                    <li>
                      <span>Integrations required(payments, APIs, etc)</span>
                    </li>
                    <li>
                      <span>Complexity of design & backend</span>
                    </li>
                  </ul>
                  <p>
                    We provide a custom quote after understanding your needs -
                    no guesswork.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will my app work on both Android and iOS?">
                  <p>Yes. We can build:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Android apps</span>
                    </li>
                    <li>
                      <span>iOS apps</span>
                    </li>
                    <li>
                      <span>Or both (cross-platform or native)</span>
                    </li>
                  </ul>
                  <p>
                    We guide you on the best approach based on your budget and
                    goals.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Can the app integrate with my existing tools and software?">
                  <p>Yes—and this is critical. We integrate your app with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Existing business systems</span>
                    </li>
                    <li>
                      <span>CRMs, ERPs, and accounting tools</span>
                    </li>
                    <li>
                      <span>Payment platforms (mobile money, cards)</span>
                    </li>
                  </ul>
                  <p>
                    This ensures your app becomes part of a connected ecosystem,
                    not a standalone tool.
                  </p>
                </FaqCardList>

                <FaqCardList faq="Can the app handle growth as we get more users?">
                  <p>Absolutely. We design apps with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Scalable architecture</span>
                    </li>
                    <li>
                      <span>Optimized backend systems</span>
                    </li>
                    <li>
                      <span>Flexible infrastructure</span>
                    </li>
                  </ul>
                  <p>Your app grows with your business.</p>
                </FaqCardList>
                <FaqCardList faq="How do you ensure the app is secure?">
                  <p>We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Secure authentication systems</span>
                    </li>
                    <li>
                      <span>Role-based access control</span>
                    </li>
                    <li>
                      <span>Data encryption</span>
                    </li>
                    <li>
                      <span>Activity logs and monitoring</span>
                    </li>
                    <li>
                      <span>Secure APIs and backend systems</span>
                    </li>
                  </ul>
                  <p>Security is built into the app from the ground up.</p>
                </FaqCardList>
                <FaqCardList faq="What happens after the app is launched?">
                  <p>
                    Launch is just the beginning. At your request, we support
                    you with:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Updates and improvements</span>
                    </li>
                    <li>
                      <span>Performance monitoring</span>
                    </li>
                    <li>
                      <span>Bug fixes</span>
                    </li>
                    <li>
                      <span>Feature upgrades</span>
                    </li>
                  </ul>
                  <p>Your app continues to evolve as your business grows.</p>
                </FaqCardList>

                <FaqCardList faq="Will the app be fast and reliable?">
                  <p>Yes. We focus heavily on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Performance optimization</span>
                    </li>
                    <li>
                      <span>Efficient architecture</span>
                    </li>
                    <li>
                      <span>Stability and crash prevention</span>
                    </li>
                  </ul>
                  <p>Your users get a smooth, reliable experience.</p>
                </FaqCardList>
                <FaqCardList faq="Can you help publish the app on app stores?">
                  <p>Yes—we handle:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Google Play Store publishing</span>
                    </li>
                    <li>
                      <span>Apple App Store submission</span>
                    </li>
                    <li>
                      <span>Approval processes and compliance</span>
                    </li>
                  </ul>
                  <p>You don’t have to deal with the technical complexities.</p>
                </FaqCardList>

                <FaqCardList faq="Do you use templates or pre-built apps?">
                  <p>No. We build every app from scratch to ensure:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Better performance</span>
                    </li>
                    <li>
                      <span>Full control</span>
                    </li>
                    <li>
                      <span>Flexibility and scalability</span>
                    </li>
                    <li>
                      <span>Unique user experience</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="What makes NTUNA.COM different">
                  <p>We don’t just build apps—we build business solutions.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>We focus on your business goals</span>
                    </li>
                    <li>
                      <span>We integrate your systems</span>
                    </li>
                    <li>
                      <span>We design for long-term growth</span>
                    </li>
                    <li>
                      <span>We provide ongoing support</span>
                    </li>
                  </ul>
                  <p>
                    You’re not just hiring developers—you’re gaining a
                    technology partner.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Features required</span>
                    </li>
                    <li>
                      <span>Define app requirements</span>
                    </li>
                    <li>
                      <span>Propose a solution and timeline</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin development</span>
                    </li>
                  </ul>
                  <p>Clear, structured, and guided from start to finish.</p>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in the efficiency and growth of their business and institution."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppsFaqsBody;
